import { apiRequestErrorFromResponse, apiUrl } from './api';

interface BrowserDownloadOptions {
  rel?: string;
}

export function triggerBrowserDownload(
  href: string,
  filename: string,
  options: BrowserDownloadOptions = {},
): void {
  if (typeof document === 'undefined') return;
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  if (options.rel !== undefined) link.rel = options.rel;
  document.body.append(link);
  link.click();
  link.remove();
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const href = URL.createObjectURL(blob);
  try {
    triggerBrowserDownload(href, filename);
  } finally {
    URL.revokeObjectURL(href);
  }
}

export async function downloadApiBlob(
  path: string,
  filename: string,
  init?: RequestInit & { fallbackCode?: string },
): Promise<void> {
  const { fallbackCode, ...requestInit } = init ?? {};
  const res = await fetch(apiUrl(path), {
    credentials: 'include',
    ...requestInit,
  });
  if (!res.ok) {
    throw await apiRequestErrorFromResponse(res, fallbackCode);
  }
  triggerBlobDownload(await res.blob(), filename);
}
